export const formatMobileMoneyAccount = (acc) => {
  return `${acc.provider} - ${acc.msisdn} (${
    acc.accountName || "N/A"
  })${acc.isDefaultPayout ? " (Default)" : ""}`;
};

export const formatBankAccount = (acc) => {
  return `${acc.bankName} - ${acc.accountNumber} (${acc.accountName || "N/A"})${
    acc.isDefaultPayout ? " (Default)" : ""
  }`;
};

export const formatWalletAccount = (acc) => {
  return `${acc.accountNumber} (${acc.accountName || "N/A"})${
    acc.isDefaultPayout ? " (Default)" : ""
  }`;
};
